module.exports = __webpack_public_path__ + "img/seabrokersLogoCircle.3f4e25e9.png";